/**
 * @param state {object} Domain state
 * @param cartId {string} Cart id
 * @param cartHeader {object} Updated cart header
 * @returns {object} Updated domain state
 */
export default (state, {cartId, cartHeader}) => {

    Object.entries(cartHeader).forEach(([cartHeaderKey, cartHeaderValue]) => {
        state.carts[cartId][cartHeaderKey] = cartHeaderValue;
    });

    return state;
};
